module.exports = __webpack_public_path__ + "img/settingssu.6ba9b418.svg";